import type { ReactNode } from 'react';
import { useSettingsForm } from '@/hooks/useSettingsForm';
import type { ShellView } from '@/providers/dashboard/ShellContext';
import { SettingsContext } from '@/providers/settings/SettingsContext';

interface SettingsProviderProps {
  children: ReactNode;
  onClose?: () => void;
  onDirtyChange?: (dirty: boolean) => void;
  onPendingNavigationResolved?: (confirmed: boolean) => void;
  onReplayOnboarding?: () => void;
  pendingNavigation?: ShellView | null;
}

export const SettingsProvider = ({
  children,
  onClose,
  onDirtyChange,
  onPendingNavigationResolved,
  onReplayOnboarding,
  pendingNavigation,
}: SettingsProviderProps) => {
  const form = useSettingsForm({
    onClose,
    onDirtyChange,
    onPendingNavigationResolved,
    onReplayOnboarding,
    pendingNavigation,
  });

  const value = { ...form, canClose: Boolean(onClose) };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
